(function(){if(window.ntAsset)return;var b='';try{var s=document.currentScript;if(!s){var a=document.getElementsByTagName('script');for(var i=0;i<a.length;i++){if(/wally2-vegardi-demo/.test(a[i].src||'')){s=a[i];break}}}if(s&&s.src)b=s.src.replace(/[^\/]*$/,'')}catch(e){}window.ntAsset=function(n){return b+n}})();
/* wally2-vegardi-demo.js — phone animation engines, ported from
   phones-section/section-5-5-integration.html (real <script> block only). */

/* Shopify asset resolver: rewrites bare `nt-vegardi-*` image srcs (static markup +
   JS-injected chat cards) to the theme CDN URL from window.WALLY2_VEGARDI_ASSETS. */
(function () {
  function resolve(root) {
    var map = window.WALLY2_VEGARDI_ASSETS || {};
    var imgs = (root || document).querySelectorAll('.vegardi-demo img');
    Array.prototype.forEach.call(imgs, function (img) {
      var s = img.getAttribute('src') || '';
      if (s.indexOf('/cdn/') !== -1 || s.indexOf('http') === 0) return;
      var i = s.lastIndexOf('nt-vegardi');
      if (i < 0) return;
      var name = s.slice(i);
      if (map[name]) img.setAttribute('src', map[name]);
    });
  }
  function init() {
    resolve(document);
    var demo = document.querySelector('.vegardi-demo');
    if (demo && 'MutationObserver' in window) {
      new MutationObserver(function () { resolve(demo); }).observe(demo, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ════════════════════════════════════════════════════════════════════════
 *  PHONE 1 — MEASURE & PLAY
 *  Measures section positions at runtime, injects keyframe values.
 * ════════════════════════════════════════════════════════════════════════ */
/* ============================================================ */
/*  PHONE 1 — MEASURE & PLAY                                     */
/*  Strategy:                                                    */
/*  1. Wait for fonts + hero image (so layout is stable).        */
/*  2. Measure offsetTop of each section we want to pause on.    */
/*  3. Inject a <style> with @keyframes vphone1-yscroll          */
/*     using the real measured translateY values.                */
/*  4. Wire up IntersectionObserver to play only when in view.   */
/* ============================================================ */
(function(){
  const phone = document.querySelector('.vphone[data-phone="1"]');
  if(!phone) return;

  const hero   = phone.querySelector('.vapp-hero');
  const header = phone.querySelector('.vapp-header');

  function measureAndInjectKeyframes(){
    const headerH = header.offsetHeight;
    const ctaH    = phone.querySelector('.vapp-cta').offsetHeight;
    const screen  = phone.querySelector('.vphone-screen');
    const restBelowHeader = 12;  // breathing room below the header
    const restAboveCta    = 16;  // breathing room above the bottom CTA

    // Sections inside .vapp-scroll, in scroll order
    const cards     = phone.querySelectorAll('.vapp-scroll > .vapp-card');
    const whatCard  = cards[1];                                       // What you'll need
    const safetyCard= cards[2];                                       // Safety notes (Best practices follows naturally)
    const stepsWrap = phone.querySelector('.vapp-steps-wrap');
    const gardi     = phone.querySelector('.vapp-gardi');
    const learn     = phone.querySelector('.vapp-learn-row');

    // Mid-section stops: bring the element's TOP to just below the header.
    const yTopAlign = (el) => Math.round((headerH + restBelowHeader) - el.offsetTop);

    // Final stop: bring the element's BOTTOM to just above the CTA.
    // This avoids the empty-space-below-content problem that yTopAlign caused
    // for the last element (there's nothing visually meaningful below it).
    const visibleBottom = screen.offsetHeight - ctaH;
    const yBottomAlign = (el) => Math.round((visibleBottom - restAboveCta) - (el.offsetTop + el.offsetHeight));

    const yWhat   = yTopAlign(whatCard);
    const ySafety = yTopAlign(safetyCard);
    const ySteps  = yTopAlign(stepsWrap);
    const yGardi  = yTopAlign(gardi);
    const yLearn  = yBottomAlign(learn);   // <-- bottom-anchored for the final pause

    const css = `
      @keyframes vphone1-yscroll{
        0%, 4%      { transform: translateY(0px); }
        10%, 13%    { transform: translateY(${yWhat}px); }
        18%, 22%    { transform: translateY(${ySafety}px); }
        28%, 65%    { transform: translateY(${ySteps}px); }
        71%, 74%    { transform: translateY(${yGardi}px); }
        80%, 92%    { transform: translateY(${yLearn}px); }
        100%        { transform: translateY(0px); }
      }
    `;

    let styleEl = document.getElementById('vphone1-dynamic-keyframes');
    if(!styleEl){
      styleEl = document.createElement('style');
      styleEl.id = 'vphone1-dynamic-keyframes';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = css;
  }

  function setupIntersection(){
    if(!('IntersectionObserver' in window)){
      phone.classList.add('is-playing');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if(e.isIntersecting){
          e.target.classList.add('is-playing');
        } else {
          e.target.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.25 });
    io.observe(phone);
  }

  // Re-measure on window resize (responsive widths shift line wraps and thus heights)
  let resizeTimer;
  function onResize(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureAndInjectKeyframes, 200);
  }

  // Boot sequence: wait for fonts + hero image, then measure
  const fontsReady = (document.fonts && document.fonts.ready)
    ? document.fonts.ready
    : Promise.resolve();

  const imageReady = new Promise(resolve => {
    if(hero.complete) return resolve();
    hero.addEventListener('load', resolve, { once: true });
    hero.addEventListener('error', resolve, { once: true });
  });

  Promise.all([fontsReady, imageReady]).then(() => {
    // One rAF tick to let layout settle after font swap
    requestAnimationFrame(() => {
      measureAndInjectKeyframes();
      setupIntersection();
      window.addEventListener('resize', onResize);
    });
  });
})();


/* ════════════════════════════════════════════════════════════════════════
 *  PHONE 2 — MEASURE & PLAY (two screens + transition)
 * ════════════════════════════════════════════════════════════════════════ */
/* ============================================================ */
/*  PHONE 2 — MEASURE & PLAY                                     */
/*  Two screens, one phone. Each screen has its own vertical     */
/*  scroll animation; the stage translates between them.         */
/*  All vertical positions are measured at runtime.              */
/* ============================================================ */
(function(){
  const phone = document.querySelector('.vphone[data-phone="2"]');
  if(!phone) return;

  const screenDetail = phone.querySelector('.vscreen-detail');
  const screenEnc    = phone.querySelector('.vscreen-enc');
  const heroImgs     = phone.querySelectorAll('img');

  function measureScreen1(){
    // For the plant detail screen we want to scroll smoothly down through:
    // hero → MY LETTUCE → ABOUT LETTUCE → GROWING PREFERENCES → end on Learn More
    const scroll = screenDetail.querySelector('.vscroll');
    const overview = screenDetail.querySelector('[data-section="overview"]');
    const growingPrefs = screenDetail.querySelector('[data-section="growing-prefs"]');
    const gardi = screenDetail.querySelector('[data-section="gardi"]');
    const learnMoreBtn = screenDetail.querySelector('[data-learn-more]');

    // Margin from top — first paint shows hero
    // Position progression: top -> mid1 -> mid2 -> settle on Learn More visible
    const screenH = screenDetail.offsetHeight;
    const rest = 16;

    // Want Learn More button visible roughly centered in viewport at the end
    const yLearnTarget = Math.round((screenH / 2) - learnMoreBtn.offsetTop - learnMoreBtn.offsetHeight/2);
    // Mid stops along the way
    const yMyLettuce = -200;  // small scroll past hero
    const yMidGroups = -480;  // through planting groups
    const yAbout = -(overview.offsetTop - rest - 40);  // ABOUT LETTUCE zone in view (just below header area)
    const yLearnSettle = yLearnTarget;

    return { yMyLettuce, yMidGroups, yAbout, yLearnSettle };
  }

  function measureScreen2(){
    const screenH = screenEnc.offsetHeight;
    const rest = 16;

    const conditions = screenEnc.querySelector('[data-section="conditions"]');
    const nutrients = screenEnc.querySelector('[data-section="nutrients"]');
    const methods = screenEnc.querySelector('[data-section="methods"]');
    const tips = screenEnc.querySelector('[data-section="tips"]');
    const love = screenEnc.querySelector('[data-section="love"]');
    const encEnd = screenEnc.querySelector('[data-section="enc-end"]');

    // Top-align each section just below the dark hero edge
    const yAlign = (el) => Math.round(rest - el.offsetTop + 40);

    const yConditions = yAlign(conditions);
    const yNutrients  = yAlign(nutrients);
    const yMethods    = yAlign(methods);
    const yTips       = yAlign(tips);
    const yLove       = yAlign(love);
    // For the end, bottom-align like phone 1
    const ctaArea = 0; // encyclopedia has no sticky CTA
    const visibleBottom = screenH - 16;
    const yEnd = Math.round(visibleBottom - rest - (encEnd.offsetTop + encEnd.offsetHeight));

    return { yConditions, yNutrients, yMethods, yTips, yLove, yEnd };
  }

  function inject(){
    const s1 = measureScreen1();
    const s2 = measureScreen2();

    const css = `
      /* ── Plant Detail vertical scroll ── */
      @keyframes vphone2-detail-scroll{
        0%, 2%      { transform:translateY(0); }
        7%, 9%      { transform:translateY(${s1.yMyLettuce}px); }
        14%, 16%    { transform:translateY(${s1.yMidGroups}px); }
        21%, 23%    { transform:translateY(${s1.yAbout}px); }
        28%, 35%    { transform:translateY(${s1.yLearnSettle}px); }
        42%         { transform:translateY(0); }      /* off-screen reset */
        100%        { transform:translateY(0); }
      }

      /* ── Encyclopedia vertical scroll ── */
      @keyframes vphone2-enc-scroll{
        0%, 40%     { transform:translateY(0); }
        46%, 49%    { transform:translateY(${s2.yConditions}px); }
        54%, 57%    { transform:translateY(${s2.yNutrients}px); }
        62%, 64%    { transform:translateY(${s2.yMethods}px); }
        69%, 72%    { transform:translateY(${s2.yTips}px); }
        76%, 78%    { transform:translateY(${s2.yEnd}px); }
        82%         { transform:translateY(0); }      /* return to top for back tap */
        100%        { transform:translateY(0); }
      }
    `;

    let styleEl = document.getElementById('vphone2-dynamic-keyframes');
    if(!styleEl){
      styleEl = document.createElement('style');
      styleEl.id = 'vphone2-dynamic-keyframes';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = css;
  }

  function setupIntersection(){
    if(!('IntersectionObserver' in window)){
      phone.classList.add('is-playing');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if(e.isIntersecting){
          e.target.classList.add('is-playing');
        } else {
          e.target.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.2 });
    io.observe(phone);
  }

  let resizeTimer;
  function onResize(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(inject, 200);
  }

  // Wait for fonts + all images before measuring (layout needs to be stable)
  const fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  const imagesReady = Promise.all(Array.from(heroImgs).map(img =>
    new Promise(r => {
      if (img.complete) return r();
      img.addEventListener('load', r, { once: true });
      img.addEventListener('error', r, { once: true });
    })
  ));

  Promise.all([fontsReady, imagesReady]).then(() => {
    requestAnimationFrame(() => {
      inject();
      setupIntersection();
      window.addEventListener('resize', onResize);
    });
  });
})();


/* ════════════════════════════════════════════════════════════════════════
 *  PHONE 3 — GARDI CHAT SEQUENCER
 *  Content config is the CHAT_CONFIG object at the top — that's what
 *  needs editing to create the Homie / Tobato variants.
 * ════════════════════════════════════════════════════════════════════════ */
/* ============================================================ */
/*  CHAT CONTENT CONFIG                                          */
/*  Change these to make the Homie variant (bok choy / leafy)    */
/*  or any other system-specific version. The structure stays.   */
/* ============================================================ */
const CHAT_CONFIG = {

  // Exchange 1 — diagnostic question
  ex1: {
    userQ: "My basil leaves are yellowing on the bottom. Should I worry?",
    gardiChunks: [
      '<p class="lead">Worth a check, not panic.</p>' +
      '<p>Bottom-leaf yellowing on basil at <b>day 24</b> usually traces back to one of these three:</p>',

      '<div class="widget widget-checklist">' +
        '<div class="check-item"><div class="check-num">1</div><div><div class="check-title">pH levels</div><div class="check-detail">Basil thrives at 5.5 to 6.5. Outside that range, iron and magnesium become hard to absorb, and yellowing follows.</div></div></div>' +
        '<div class="check-item"><div class="check-num">2</div><div><div class="check-title">Reservoir age</div><div class="check-detail">Your last full reset was 38 days ago. After 30 days, nutrient ratios drift out of balance.</div></div></div>' +
        '<div class="check-item"><div class="check-num">3</div><div><div class="check-title">Water temperature</div><div class="check-detail">Warm weather raises reservoir temp, which lowers dissolved oxygen and stresses roots.</div></div></div>' +
      '</div>',

      '<p>Based on your reservoir history, <b>item 2</b> is my best guess. Start there, or pull in a fuller diagnosis first?</p>'
    ],
    ctas: [
      { label: 'Start guided reservoir reset', style: 'primary', arr: '→' },
      { label: 'Open Plant Doctor for full diagnosis', style: 'secondary', icon: 'doctor' }
    ]
  },

  // Exchange 2 — advisory question (with widgets demonstrating depth)
  ex2: {
    userQ: "What can I grow now? Is it a good time to plant tomatoes?",
    gardiChunks: [
      '<p>Yes, this is a strong window for tomatoes. Your climate is <b>frost-free year-round</b>, and we are deep in heat-loving-crop season.</p>',

      '<div class="widget widget-climate">' +
        '<div class="climate-cell">' +
          '<svg class="cell-ic" viewBox="0 0 24 24" fill="none" stroke="#2D6A4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12c0 5-3 9-9 9s-9-4-9-9 4-9 9-9c2 0 4 1 5 2"/><path d="M12 7v5l3 2"/></svg>' +
          '<div class="cell-text"><div class="cell-label">Zone</div><div class="cell-val">10b</div></div>' +
        '</div>' +
        '<div class="climate-divider"></div>' +
        '<div class="climate-cell">' +
          '<svg class="cell-ic" viewBox="0 0 24 24" fill="none" stroke="#6B3FA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/></svg>' +
          '<div class="cell-text"><div class="cell-label">Frost-free</div><div class="cell-val">Year-round</div></div>' +
        '</div>' +
        '<div class="climate-divider"></div>' +
        '<div class="climate-cell">' +
          '<svg class="cell-ic" viewBox="0 0 24 24" fill="none" stroke="#C9952B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z"/></svg>' +
          '<div class="cell-text"><div class="cell-label">Avg now</div><div class="cell-val">25°C</div></div>' +
        '</div>' +
        '<svg class="climate-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>' +
      '</div>',

      '<p>You have 6 slots open in your Wally Smart 32. Here are the top picks for this season at your match score:</p>',

      '<div class="widget widget-plants">' +
        '<div class="plant-card"><div class="card-img-wrap"><img src="'+window.ntAsset('nt-vegardi-plant-tomato.webp')+'" alt=""><div class="match-badge">96%</div></div><div class="card-info"><div class="card-name">Tomato</div><div class="card-meta">Thrives · ~80d</div></div></div>' +
        '<div class="plant-card"><div class="card-img-wrap"><img src="'+window.ntAsset('nt-vegardi-plant-basil.webp')+'" alt=""><div class="match-badge">94%</div></div><div class="card-info"><div class="card-name">Genovese basil</div><div class="card-meta">Thrives · ~52d</div></div></div>' +
        '<div class="plant-card"><div class="card-img-wrap"><img src="'+window.ntAsset('nt-vegardi-plant-mint.webp')+'" alt=""><div class="match-badge">89%</div></div><div class="card-info"><div class="card-name">Mint</div><div class="card-meta">Cut-and-come-again</div></div></div>' +
        '<div class="plant-card"><div class="card-img-wrap"><img src="'+window.ntAsset('nt-vegardi-plant-oregano.webp')+'" alt=""><div class="match-badge">85%</div></div><div class="card-info"><div class="card-name">Oregano</div><div class="card-meta">Thrives · ~90d</div></div></div>' +
      '</div>',

      '<p>Want me to set up a planting group for any of these?</p>'
    ]
  }
};

/* ============================================================ */
/*  CHAT ENGINE — sequencer                                      */
/*  Drives the live chat playback. JS-only choreography.         */
/*  Loop length: ~40 seconds for two exchanges + read time.      */
/* ============================================================ */
(function(){
  const phone = document.querySelector('.vphone[data-phone="3"]');
  if(!phone) return;

  const chatArea = phone.querySelector('[data-chat-area]');
  const timestampEl = chatArea.querySelector('.vchat-timestamp');

  let playToken = 0;
  let isPlaying = false;

  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  const scrollDown = () => { chatArea.scrollTop = chatArea.scrollHeight; };

  function reset(){
    Array.from(chatArea.children).forEach(child => {
      if(child !== timestampEl) chatArea.removeChild(child);
    });
    chatArea.scrollTop = 0;
  }

  async function typeUserMessage(text, msPerChar, token){
    const msg = document.createElement('div');
    msg.className = 'msg user';
    msg.innerHTML = '<div class="bubble user"><span class="txt"></span><span class="caret"></span></div>';
    chatArea.appendChild(msg);
    requestAnimationFrame(() => msg.classList.add('is-in'));
    scrollDown();

    const txt = msg.querySelector('.txt');
    const caret = msg.querySelector('.caret');

    for(let i = 0; i < text.length; i++){
      if(token !== playToken) return;
      txt.textContent += text[i];
      const jitter = (Math.random() * 26) - 13;
      if(i % 5 === 0) scrollDown();
      await sleep(msPerChar + jitter);
    }
    caret.remove();
    scrollDown();
  }

  async function showTypingIndicator(durationMs, token){
    const ind = document.createElement('div');
    ind.className = 'typing';
    ind.innerHTML = '<div class="msg-av">✦</div><div class="typing-bubble"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>';
    chatArea.appendChild(ind);
    requestAnimationFrame(() => ind.classList.add('is-in'));
    scrollDown();

    await sleep(durationMs);
    if(token !== playToken){ ind.remove(); return; }

    ind.classList.remove('is-in');
    await sleep(180);
    ind.remove();
  }

  async function streamGardiMessage(chunks, gapMs, token, opts){
    opts = opts || {};
    const msg = document.createElement('div');
    msg.className = 'msg gardi';
    msg.innerHTML = '<div class="msg-av">✦</div><div class="bubble gardi"></div>';
    chatArea.appendChild(msg);
    requestAnimationFrame(() => msg.classList.add('is-in'));
    scrollDown();

    const bubble = msg.querySelector('.bubble');

    for(let i = 0; i < chunks.length; i++){
      if(token !== playToken) return;
      const chunk = document.createElement('div');
      chunk.className = 'chunk';
      chunk.innerHTML = chunks[i];
      bubble.appendChild(chunk);
      requestAnimationFrame(() => chunk.classList.add('is-in'));
      scrollDown();
      await sleep(gapMs);
    }

    if(opts.ctas && token === playToken){
      const stack = document.createElement('div');
      stack.className = 'cta-stack';
      bubble.appendChild(stack);

      for(const ctaCfg of opts.ctas){
        const btn = document.createElement('button');
        btn.className = 'cta-pill cta-' + ctaCfg.style;
        let inner = '';
        if(ctaCfg.icon === 'doctor'){
          inner = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>';
        }
        inner += ctaCfg.label;
        if(ctaCfg.arr){ inner += ' <span class="arr">' + ctaCfg.arr + '</span>'; }
        btn.innerHTML = inner;
        stack.appendChild(btn);

        await sleep(120);
        if(token !== playToken) return;
        requestAnimationFrame(() => btn.classList.add('is-in'));
        scrollDown();
      }
    }
  }

  async function playExchange(ex, token){
    await typeUserMessage(ex.userQ, 48, token);
    if(token !== playToken) return;
    await sleep(450);
    if(token !== playToken) return;
    await showTypingIndicator(1300, token);
    if(token !== playToken) return;
    await streamGardiMessage(ex.gardiChunks, 540, token, { ctas: ex.ctas });
  }

  async function playOnce(){
    const myToken = ++playToken;

    reset();
    await sleep(650);
    if(myToken !== playToken) return;

    await playExchange(CHAT_CONFIG.ex1, myToken);
    if(myToken !== playToken) return;

    // Hold so the viewer reads the CTAs of exchange 1
    await sleep(4000);
    if(myToken !== playToken) return;

    await playExchange(CHAT_CONFIG.ex2, myToken);
    if(myToken !== playToken) return;

    // Final hold on the full conversation
    await sleep(5500);
  }

  async function loop(){
    if(!isPlaying) return;
    await playOnce();
    if(isPlaying){
      await sleep(400);
      if(isPlaying) loop();
    }
  }

  function setupIntersection(){
    if(!('IntersectionObserver' in window)){
      isPlaying = true; loop(); return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if(e.isIntersecting && !isPlaying){
          isPlaying = true;
          loop();
        } else if(!e.isIntersecting && isPlaying){
          isPlaying = false;
          playToken++;  // cancels in-flight playthrough
        }
      });
    }, { threshold: 0.2 });
    io.observe(phone);
  }

  // Wait for fonts and the plant images so layout is stable
  const fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  const imgs = ['nt-vegardi-plant-tomato.webp','nt-vegardi-plant-basil.webp','nt-vegardi-plant-mint.webp','nt-vegardi-plant-oregano.webp'].map(window.ntAsset);
  const imgsReady = Promise.all(imgs.map(src => new Promise(r => {
    const img = new Image();
    img.onload = img.onerror = r;
    img.src = src;
  })));
  Promise.all([fontsReady, imgsReady]).then(setupIntersection);
})();
